import * as authAPI from './auth.api'
import * as commonAPI from './common.api'
export { authAPI, commonAPI }
